import { z } from 'zod';

export const NewParticipantZod = z.object({
    email: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    suffix: z.string().optional(),
    domicileStateCode: z.string(),
});
export type NewParticipant = z.infer<typeof NewParticipantZod>;
